import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

function sentryStoreUrl(dsn: string): string | null {
  try {
    const u = new URL(dsn);
    const key = u.username;
    const project = u.pathname.replace(/^\//, '').split('/')[0];
    if (!key || !project) return null;
    return `${u.protocol}//${u.host}/api/${project}/store/?sentry_key=${encodeURIComponent(key)}`;
  } catch {
    return null;
  }
}

function readDsn(): string {
  if (typeof process !== 'undefined') {
    const fromProc = String(process.env?.['SENTRY_DSN'] || '').trim();
    if (fromProc) return fromProc;
  }
  const fromEnv = String((environment as { sentryDsn?: string }).sentryDsn || '').trim();
  if (fromEnv) return fromEnv;
  if (typeof window !== 'undefined') {
    return String((window as { MB_SENTRY_DSN?: string }).MB_SENTRY_DSN || '').trim();
  }
  return '';
}

@Injectable()
export class MbErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    console.error(error);
    const url = sentryStoreUrl(readDsn());
    if (!url || typeof fetch === 'undefined') return;
    const err = error instanceof Error ? error : new Error(String(error));
    const body = {
      platform: 'javascript',
      level: 'error',
      timestamp: new Date().toISOString(),
      tags: { app: 'seller-panel' },
      exception: {
        values: [{ type: err.name, value: err.message, stacktrace: { frames: [{ filename: err.stack || '' }] } }],
      },
    };
    void fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {});
  }
}
